import billmaHttpClient from '@/services/http/billmaHttpClient'
import { getUserLocale } from '@/utils/userSettings'

export const billmaApiGetDocuments = (sinisterId) => {
  const params = new URLSearchParams()
  params.set('externalClaimId', sinisterId)
  if (getUserLocale()) params.set('lang', getUserLocale())

  return billmaHttpClient.get(`/bridge/api/documents?${params.toString()}`)
}
